module.exports = "/packs/images/icons/icon-refer-ba3ea0a04f70d949a4276fd695df0902.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icons/icon-refer.svg
// module id = 1793
// module chunks = 0